<template>
  <div v-if="qaStatus === 'incomplete'" class="mt-4 badge text-gray-800 bg-gray-100 ring-1 ring-inset ring-gray-600">
    QA: Incomplete
  </div>
  <div v-if="qaStatus === 'complete'" class="mt-4 badge badge-success capitalize">
    QA: Complete
  </div>
</template>

<script setup>

const { qaStatus } = defineProps({
  qaStatus: String
});

</script>
